import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import styles from "../../styles/will-you.module.scss";
export default function WillYou() {
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0.5,
    delay: 0.5,
    triggerOnce: false,
  });
  return (
    <div id="gameplay" className={styles.root}>
      <div className="wrap">
        <div className="grid lg:grid-cols-2 lg:gap-8">
          <div className="mb-5 lg:mb-0 lg:order-2">
            <p className="heading text-center lg:text-left mb-2 ">
              WILL YOU CONQUER <br /> OR GET BURNT?
            </p>
            <p className="paragraph text-center lg:text-left">
              Each weekly tournament has automatically assigned battles. If you win - you progress to the next round, to ultimately fight for the grand prize and become a champion. But if you lose - your NFT gets burnt to a pile of dust and you will need to either buy another alive warrior off the marketplace or revive/mint a character for the next season.
            </p>
          </div>
          <div ref={ref} className="grid grid-cols-2 gap-x-5 lg:gap-x-8 gap-y-3 lg:order-1">
            <div className={styles.card}>
              <div className={`${styles.inner} ${styles.loser} overflow-hidden `}>
                <motion.img
                  initial={{ y: "100%" }}
                  animate={inView ? { y: 0, transition: { delay: 0.5 } } : { y: "-100%" }}
                  className="w-full"
                  src={"/assets/will-you/loser.png"}
                  alt={"Loser"}
                />
              </div>
            </div>

            <div className={styles.card}>
              <div className={`${styles.inner} overflow-hidden `}>
                <motion.img
                  initial={{ y: "-100%" }}
                  animate={inView ? { y: 0, transition: { delay: 0.0 } } : { y: "100%" }}
                  className="w-full"
                  src={"/assets/will-you/winner.png"}
                  alt={"Winner"}
                />
              </div>
            </div>
            <p className={styles.role}>Lose</p>
            <p className={styles.role}>Victory</p>
          </div>
        </div>
      </div>
    </div>
  );
}
